import { render, staticRenderFns } from "./PayoutEventDetail.vue?vue&type=template&id=97fa0d3c&"
import script from "./PayoutEventDetail.vue?vue&type=script&lang=js&"
export * from "./PayoutEventDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports